import styled from 'styled-components';
import { colors, font, spacing } from '@chegg-ui/theme';
import { Link } from '@chegg-ui/link';
var dark = colors.dark;
var size = font.size,
  weight = font.weight,
  family = font.family,
  lineHeight = font.lineHeight;
var px16 = size.px16,
  px18 = size.px18;
var bold = weight.bold;
var aspira = family.aspira;
export var ReviewMopContainer = styled.div.withConfig({
  componentId: "sc-1cveygy-0"
})(["color:", ";font-family:", ";font-size:", ";line-height:", ";"], dark, aspira, px18, lineHeight.md);
export var ReviewMopHeading = styled.div.withConfig({
  componentId: "sc-1cveygy-1"
})(["align-items:center;display:flex;font-weight:", ";justify-content:space-between;margin-bottom:", ";"], bold, spacing.px8);
export var ReviewMopLink = styled(Link).withConfig({
  componentId: "sc-1cveygy-2"
})(["font-size:", ";"], px18);
export var ReviewMopAddressContainer = styled.div.withConfig({
  componentId: "sc-1cveygy-3"
})(["margin-top:", ";margin-left:", ";font-size:", ";"], spacing.px16, spacing.px64, px16);
export var ReviewMopAddressText = styled.p.withConfig({
  componentId: "sc-1cveygy-4"
})(["padding-bottom:", ";margin:0;"], spacing.px4);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/ReviewMopView/styled.js
// module id = 4575
// module chunks = 11